import React from 'react'

import { Ink } from '@acorns/web-components'
import styled from 'styled-components'

import chevronSVG from 'assets/icons/chevron-gray.svg'
import { withTrackClicked } from 'components/trackers'
import { theme } from 'theme'
import { SEARCH_RESULT_ITEM } from 'utils/testing/testIDs'

import EmployerLogo from '../EmployerLogo'
import { AddEmployerButton, Props } from '../SearchResultItem'

const Container = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: ${theme('styles.borderRadius')};
  cursor: pointer;
  display: flex;
  height: 70px;
  padding: 20px;
  position: relative;
  user-select: none;
  width: 100%;

  &:focus {
    outline: 0;
  }
`

const StyledAddEmployerButton = styled(AddEmployerButton)`
  flex-direction: row-reverse;
`

const Text = styled.div`
  color: ${theme('colors.slate')};
  font-size: 14px;
  flex: 1;
`

const Chevron = styled.img`
  transform: rotate(270deg);
  transition: transform 300ms;
  position: absolute;
  right: 20px;
`

const TrackedContainer = withTrackClicked<any, Props>((props) => ({
  object_name: 'directDepositSearchSelect',
  screen: 'directDepositSearch',
  screen_name: 'directDepositSearch',
  destination: 'directDepositOnline',
  index_count: `${props.employerCount}`,
  index_position_tapped: `${props.employerIndex}`,
  cta_url: props.ctaUrl,
  tracking_id: props.trackingId,
  click_switch_target_id: props.clickSwitchTargetId,
}))(Container)

export const AddEmployerItem = withTrackClicked<any, any>(() => ({
  object_name: 'directDepositSearchAdd',
  screen: 'directDepositSearch',
  screen_name: 'directDepositSearch',
  destination: 'directDepositPDF',
}))(StyledAddEmployerButton)

export default (props: Props) => (
  <TrackedContainer
    onClick={props.onClick}
    employerCount={props.employerCount}
    employerIndex={props.employerIndex}
    employerId={props.employerId}
    employerName={props.employerName}
    ctaUrl={props.ctaUrl}
    trackingId={props.trackingId}
    clickSwitchTargetId={props.clickSwitchTargetId}
    requiresEmployerMailingAddress={props.requiresEmployerMailingAddress}
    switchType={props.switchType}
    data-employer-name={props.employerName}
    data-employer-id={props.employerId}
    data-cta-url={props.ctaUrl}
    data-click-switch-target-id={props.clickSwitchTargetId}
    data-switch-type={props.switchType}
    data-testid={SEARCH_RESULT_ITEM}
    data-require-address={props.requiresEmployerMailingAddress}
  >
    <Ink opacity={0.02} />
    <EmployerLogo src={props.logoUrl} />
    <Text>{props.employerName}</Text>
    <Chevron src={chevronSVG} className="chevron" alt="select employer" />
  </TrackedContainer>
)
